import React from 'react';
import { ISearchQuery } from './ISearchQuery';
import { useGetChecksIncomingExpectedQuery } from 'API/accounting/AccountingApi';
import { SpinnerTW } from 'tailwindComponents/spinnerTW/SpinnerTW';
import { IPotentialMatch } from './IPotentialMatch';
import { ExpectedCheckTableDisplay } from './ExpectedCheckTableDisplay';

export interface IExpectedCheckSearchProps {
  query: ISearchQuery;
  accountNumber: string;
  setPotentialMatch: (x: IPotentialMatch) => void;
}

export const ExpectedCheckSearch: React.FC<IExpectedCheckSearchProps> = ({
  query,
  setPotentialMatch,
  accountNumber,
}) => {
  const { data, isLoading } = useGetChecksIncomingExpectedQuery(query);
  return (
    <>
      {isLoading && <SpinnerTW />}
      {!!data?.content.length && (
        <ExpectedCheckTableDisplay data={data} accountNumber={accountNumber} setPotentialMatch={setPotentialMatch} />
      )}
    </>
  );
};
